import type { PermissionAccessNode } from './permission-access.util';

export const FEATURE_ACCESS_WORKS_READ: PermissionAccessNode = {
  anyOf: ['platform.works.read', 'tenant.works.read', 'me.works.read']
};

export const FEATURE_ACCESS_WORKS_MANUAL_CREATE: PermissionAccessNode = {
  anyOf: ['platform.works.manual_create', 'tenant.works.manual_create']
};

export const FEATURE_ACCESS_WORKS_UPDATE: PermissionAccessNode = {
  anyOf: ['platform.works.update', 'tenant.works.update']
};

export const FEATURE_ACCESS_ABSENCES_READ: PermissionAccessNode = {
  anyOf: [
    { allOf: ['platform.absences.read', 'platform.absence_types.read'] },
    { allOf: ['tenant.absences.read', 'tenant.absence_types.read'] },
    { allOf: ['me.absences.read', 'me.absence_types.read'] }
  ]
};

export const FEATURE_ACCESS_ABSENCES_CREATE: PermissionAccessNode = {
  anyOf: [
    { allOf: ['platform.absences.create', 'platform.absence_types.read'] },
    { allOf: ['tenant.absences.create', 'tenant.absence_types.read'] },
    { allOf: ['me.absences.create', 'me.absence_types.read'] }
  ]
};

export const FEATURE_ACCESS_ABSENCES_UPDATE: PermissionAccessNode = {
  anyOf: [
    { allOf: ['platform.absences.update', 'platform.absence_types.read'] },
    { allOf: ['tenant.absences.update', 'tenant.absence_types.read'] },
    { allOf: ['me.absences.update', 'me.absence_types.read'] }
  ]
};

export const FEATURE_ACCESS_REQUESTS_READ: PermissionAccessNode = {
  anyOf: [
    { allOf: ['platform.requests.read', 'platform.users.read'] },
    { allOf: ['tenant.requests.read', 'tenant.users.read'] },
    'me.requests.read'
  ]
};

export const FEATURE_ACCESS_REQUESTS_CREATE: PermissionAccessNode = {
  anyOf: ['platform.requests.create', 'tenant.requests.create', 'me.requests.create']
};

export const FEATURE_ACCESS_REQUESTS_UPDATE: PermissionAccessNode = {
  anyOf: ['platform.requests.update', 'tenant.requests.update', 'me.requests.update']
};

export const FEATURE_ACCESS_REQUESTS_REPLY_CREATE: PermissionAccessNode = {
  anyOf: ['platform.requests.replies.create', 'tenant.requests.replies.create', 'me.requests.replies.create']
};

export const FEATURE_ACCESS_SHIFTS_CALENDAR_READ: PermissionAccessNode = {
  anyOf: ['platform.shifts.calendar.read', 'tenant.shifts.calendar.read', 'me.shifts.calendar.read']
};

export const FEATURE_ACCESS_SHIFTS_READ: PermissionAccessNode = {
  anyOf: ['platform.shifts.read', 'tenant.shifts.read']
};

export const FEATURE_ACCESS_SHIFTS_MANAGE: PermissionAccessNode = {
  anyOf: ['platform.shifts.manage', 'tenant.shifts.manage']
};

export const FEATURE_ACCESS_SHIFTS_ASSIGN: PermissionAccessNode = {
  anyOf: ['platform.shifts.assign', 'tenant.shifts.assign']
};

export const FEATURE_ACCESS_SHIFTS_ATTENDANCE_READ: PermissionAccessNode = {
  allOf: [
    { anyOf: ['platform.shifts.calendar.read', 'tenant.shifts.calendar.read'] },
    { anyOf: ['platform.users.read', 'tenant.users.read'] }
  ]
};

export const FEATURE_ACCESS_OVERTIME_READ: PermissionAccessNode = {
  anyOf: ['platform.overtime.read', 'tenant.overtime.read']
};

export const FEATURE_ACCESS_OVERTIME_APPROVE: PermissionAccessNode = {
  allOf: [
    { anyOf: ['platform.overtime.read', 'tenant.overtime.read'] },
    { anyOf: ['platform.overtime.approve', 'tenant.overtime.approve'] }
  ]
};

export const FEATURE_ACCESS_OVERTIME_LOCK: PermissionAccessNode = {
  allOf: [
    { anyOf: ['platform.overtime.read', 'tenant.overtime.read'] },
    { anyOf: ['platform.overtime.lock', 'tenant.overtime.lock'] }
  ]
};

export const FEATURE_ACCESS_STATS_WORKS_READ: PermissionAccessNode = {
  anyOf: ['platform.stats.works.read', 'tenant.stats.works.read', 'me.stats.works.read']
};

export const FEATURE_ACCESS_STATS_ABSENCES_READ: PermissionAccessNode = {
  anyOf: ['platform.stats.absences.read', 'tenant.stats.absences.read', 'me.stats.absences.read']
};

export const FEATURE_ACCESS_ADVANCED_REPORTS_READ: PermissionAccessNode = {
  anyOf: ['platform.stats.advanced_reports.read', 'tenant.stats.advanced_reports.read']
};

export const FEATURE_ACCESS_SELF_BI_READ: PermissionAccessNode = {
  anyOf: ['platform.stats.self_bi.read', 'tenant.stats.self_bi.read']
};

export const FEATURE_ACCESS_SELF_BI_MANAGE: PermissionAccessNode = {
  anyOf: ['platform.stats.self_bi.manage', 'tenant.stats.self_bi.manage']
};

export const FEATURE_ACCESS_USERS_READ: PermissionAccessNode = {
  anyOf: ['platform.users.read', 'tenant.users.read']
};

export const FEATURE_ACCESS_USERS_CREATE: PermissionAccessNode = {
  anyOf: ['platform.users.create', 'tenant.users.create']
};

export const FEATURE_ACCESS_USERS_UPDATE: PermissionAccessNode = {
  anyOf: ['platform.users.update', 'tenant.users.update']
};

export const FEATURE_ACCESS_USERS_PERMISSIONS_READ: PermissionAccessNode = {
  anyOf: ['platform.users.permissions.read', 'tenant.users.permissions.read']
};

export const FEATURE_ACCESS_USERS_ROLES_READ: PermissionAccessNode = {
  anyOf: ['platform.users.roles.read', 'tenant.users.roles.read']
};

export const FEATURE_ACCESS_USERS_ROLES_MANAGE: PermissionAccessNode = {
  anyOf: [
    { allOf: ['platform.users.roles.assign', 'platform.users.roles.revoke'] },
    { allOf: ['tenant.users.roles.assign', 'tenant.users.roles.revoke'] }
  ]
};

export const FEATURE_ACCESS_USERS_PERMISSIONS_OVERRIDE: PermissionAccessNode = {
  anyOf: ['platform.users.permissions.override', 'tenant.users.permissions.override']
};

export const FEATURE_ACCESS_USERS_CONTRACTS_READ: PermissionAccessNode = {
  anyOf: ['platform.users.contracts.read', 'tenant.users.contracts.read']
};

export const FEATURE_ACCESS_USERS_CONTRACTS_CREATE: PermissionAccessNode = {
  anyOf: ['platform.users.contracts.create', 'tenant.users.contracts.create']
};

export const FEATURE_ACCESS_USERS_CONTRACTS_UPDATE: PermissionAccessNode = {
  anyOf: ['platform.users.contracts.update', 'tenant.users.contracts.update']
};

export const FEATURE_ACCESS_OVERTIME_RULES_READ: PermissionAccessNode = {
  anyOf: ['platform.overtime.rules.read', 'tenant.overtime.rules.read']
};

export const FEATURE_ACCESS_ATTACHMENTS_READ: PermissionAccessNode = {
  anyOf: ['platform.attachments.read', 'tenant.attachments.read']
};

export const FEATURE_ACCESS_ATTACHMENTS_CREATE: PermissionAccessNode = {
  anyOf: ['platform.attachments.create', 'tenant.attachments.create']
};

export const FEATURE_ACCESS_CONTRACT_TYPES_READ: PermissionAccessNode = {
  anyOf: ['platform.contract_types.read', 'tenant.contract_types.read']
};

export const FEATURE_ACCESS_CONTRACT_TYPES_CREATE: PermissionAccessNode = {
  anyOf: ['platform.contract_types.create', 'tenant.contract_types.create']
};

export const FEATURE_ACCESS_CONTRACT_TYPES_UPDATE: PermissionAccessNode = {
  anyOf: ['platform.contract_types.update', 'tenant.contract_types.update']
};

export const FEATURE_ACCESS_PROJECTS_READ: PermissionAccessNode = {
  anyOf: ['platform.projects.read', 'tenant.projects.read', 'me.projects.read']
};

export const FEATURE_ACCESS_PROJECTS_CREATE: PermissionAccessNode = {
  anyOf: ['platform.projects.create', 'tenant.projects.create']
};

export const FEATURE_ACCESS_PROJECTS_UPDATE: PermissionAccessNode = {
  anyOf: ['platform.projects.update', 'tenant.projects.update']
};

export const FEATURE_ACCESS_PROJECTS_USERS_READ: PermissionAccessNode = {
  anyOf: ['platform.projects.users.read', 'tenant.projects.users.read']
};

export const FEATURE_ACCESS_SITES_READ: PermissionAccessNode = {
  anyOf: ['platform.sites.read', 'tenant.sites.read']
};

export const FEATURE_ACCESS_SITES_CREATE: PermissionAccessNode = {
  anyOf: ['platform.sites.create', 'tenant.sites.create']
};

export const FEATURE_ACCESS_SITES_UPDATE: PermissionAccessNode = {
  anyOf: ['platform.sites.update', 'tenant.sites.update']
};

export const FEATURE_ACCESS_SITES_USERS_READ: PermissionAccessNode = {
  anyOf: ['platform.sites.users.read', 'tenant.sites.users.read']
};

export const FEATURE_ACCESS_ACTIVITIES_READ: PermissionAccessNode = {
  anyOf: ['platform.activities.read', 'tenant.activities.read', 'me.activities.read']
};

export const FEATURE_ACCESS_ACTIVITIES_CREATE: PermissionAccessNode = {
  anyOf: ['platform.activities.create', 'tenant.activities.create']
};

export const FEATURE_ACCESS_ACTIVITIES_UPDATE: PermissionAccessNode = {
  anyOf: ['platform.activities.update', 'tenant.activities.update']
};

export const FEATURE_ACCESS_ABSENCE_TYPES_READ: PermissionAccessNode = {
  anyOf: ['platform.absence_types.read', 'tenant.absence_types.read', 'me.absence_types.read']
};

export const FEATURE_ACCESS_ABSENCE_TYPES_CREATE: PermissionAccessNode = {
  anyOf: ['platform.absence_types.create', 'tenant.absence_types.create']
};

export const FEATURE_ACCESS_ABSENCE_TYPES_UPDATE: PermissionAccessNode = {
  anyOf: ['platform.absence_types.update', 'tenant.absence_types.update']
};
